<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

@if (data.title) {
  <h1 mat-dialog-title gta="dialog-tutorials__title">{{ data.title }}</h1>
}
<p mat-dialog-content [style.whiteSpace]="'pre-line'" gta="dialog-tutorials__message">{{ data.description }}</p>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close gta="dialog-tutorials__button-dismiss">{{ data.dismissButtonLabel }}</button>
  @if (data.confirmButtonLabel) {
    <button mat-button gta="dialog-tutorials__button-cta" (click)="openTutorial(data.tutorial)">{{
      data.confirmButtonLabel
    }}</button>
  }
</div>
